<template lang="pug">
  #contract-neo-order
    header-for-top-page(:client_no="client_no", :firm_name="firm_name")
    header-menu(:neo_contract_status="neo_contract_status", :chat_contract_status="chat_contract_status", :isLoadingHeader="isLoadingHeader", :sales_channel="sales_channel", :has_special_priced_item="has_special_priced_item", :display_e_invoice_flg="display_e_invoice_flg")
    template(v-if="isLoadingHeader === true")
      loading
    template(v-else)
      router-view.form-box.mx-auto(:has_special_priced_item="has_special_priced_item", :neo_contract="neo_contract", :neo_contract_status="neo_contract_status", :chat_contract="chat_contract", :chat_contract_status="chat_contract_status", v-model="regist_data", :plan_change_data="plan_change_data")
</template>

<script>
/* eslint-disable */
import HeaderForTopPage from "@/components/supportSite/HeaderForTopPage";
import HeaderMenu from "@/components/supportSite/HeaderMenu";
import Loading from "@/components/Loading";
import Api from '@/repositories/api';
const HeaderInfoRepository = Api.get('c205HeaderInfo');

export default {
  name: "Index",
  components: {
    HeaderForTopPage,
    HeaderMenu,
    Loading,
  },
  data() {
    return {
      // お客様番号
      client_no: '- -',
      // 会社名
      firm_name: '- -',
      // 販売種別
      sales_channel: '- -',
      // 優待価格商品保有フラグ
      has_special_priced_item: false,
      // 電子請求システムの表示フラグ
      display_e_invoice_flg: false,
      // NEOの契約情報ステータス
      neo_contract: null,
      neo_contract_status: null,
      // ChatLuckの契約情報ステータス
      chat_contract: null,
      chat_contract_status: null,
      // ローディングのステータス
      isLoadingHeader: false,
      // 登録する入力内容
      regist_data: {
        // 契約番号
        contract_no: null,
        // プラン
        plan_name: null,
        plan_user: null,
        // desknet'sNEO
        app_suite_user: null,
        web_conferencing: null,
        option_service: false,
        option_room_mgr: false,
        option_expense_settlement: false,
        clouza_check: false,
        clouza_input: null,
        clouza_company_code: null,
        paid_leave_option: false,
        option_disk: false,
        option_disk_size: 1,
        option_sync: false,
        option_sync_input: null,
        option_dn_drive: false,
        option_dn_drive_disk_size: 1,
        security_option: false,
        basic_auth: false,
        basic_auth_user: "",
        basic_auth_password: "",
        basic_auth_ip: "",
        ip_restrictions: false,
        ip_restrictions_ip: "",
        secure_browser: false,
        secure_browser_terminal: '01',
        secure_browser_device: null,
        secure_browser_ip: "",
        client_auth: false,
        client_auth_input: null,
        client_auth_ip: "",
        mail_service: false,
        web_arena: false,
        web_arena_domain: "",
        web_arena_input: null,
        cyber: false,
        cyber_input: null,
        cyber_capacity: "00",
        cyber_option: [],
        cyber_keep_period: "00",
        mail_security_service: false,
        mailgates: false,
        mailgates_domain: "",
        mailgates_input: null,
        mailgates_option: [],
        sub_domain: "",
        migration: false,
        migration_url: "",
        preferred_date: "",
        estimate: "",
        remarks: "",
        migration_date: "",
        migration_time_from: null,
        migration_time_to: null,
        provision_check : false,
        contract_type: 0
      },

      // プラン変更データ
      plan_change_data: {
        // プラン変更申し込みの表示切替フラグ
        show_change_plan: false,
        // 契約番号
        contract_no: null,
        // 変更前のプラン
        before_plan: [],
        // 変更後のプラン
        after_plan: '',
        // 変更後のユーザー数
        plan_user: '',
        // desknet's NEOサブドメイン名
        neo_sub_domain: '',
        // 試使用からの移行フラグ（NEO）
        migration: false,
        // 試使用環境URL
        migration_url: '',
        // ChatLuckサブドメイン名
        chat_sub_domain: '',
        // 試使用からの移行フラグ（Chat）
        chat_migration: false,
        // ChatLuck試使用環境URL
        chat_migration_url: '',
        // 変更希望日
        preferred_date: '',
        // 試使用からの移行作業日
        migration_date: '',
        // 試使用からの移行開始時間
        migration_time_from: '',
        // 試使用からの移行終了時間
        migration_time_to: '',
        // お見積番号
        estimate_no: '',
        // 備考
        order_remarks: '',
        // サービス利用約款など
        provision_check: false,
        // 変更前のユーザー数
        user_list: {},
      }
    }
  },
  methods: {
    setHeader() {
      // システムエラー画面の場合は何もしない
      if (this.$route.name.includes('SystemError') === false) {
        // 読み込み中
        this.isLoadingHeader = true;
        // ヘッダー情報を初期化する
        this.client_no = '- -'
        this.firm_name = '- -'

        // 画面表示前共通処理を実行する
        HeaderInfoRepository.get()
          .then((response) => {
            // NEO
            this.neo_contract = response.data.common.neo.contract
            this.neo_contract_status = response.data.common.neo.contract === true ? response.data.common.neo.contract_status : false

            // chat
            this.chat_contract = response.data.common.chat.contract
            this.chat_contract_status = response.data.common.chat.contract === true ? response.data.common.chat.contract_status : false

            // 顧客番号を取得
            this.client_no = response.data.common.client.client_no
            // 会社名を取得
            this.firm_name = response.data.common.client.firm_name
            // 販売種別
            this.sales_channel = response.data.common.client.sales_channel
            // 優待価格商品保有フラグを取得
            this.has_special_priced_item = response.data.common.client.has_special_priced_item
            // 電子請求システムの表示フラグを取得
            this.display_e_invoice_flg = response.data.common.client.is_e_invoice

            // 各画面にアクセスできないはずのユーザがURL直打ちでアクセスした場合、トップページに強制遷移する
            let iAlert = 0
            // エラーメッセージの番号を設定する
            // chatが環境構築中の場合は、NEOの契約申込画面へ遷移したにトップページへ遷移する
            if ((this.$route.name === 'ContractNeoOrder' || this.$route.name === 'ContractNeoConfirm') && this.chat_contract_status === '3') {
              iAlert = 4
            }
            // NEOが環境構築中の場合は、chatの契約申込画面へ遷移したにトップページへ遷移する
            else if ((this.$route.name === 'ContractChatOrder' || this.$route.name === 'ContractChatConfirm') && this.neo_contract_status === '3') {
              iAlert = 5
            }
            // NEOが契約中の場合は、NEOの契約申込画面へ遷移したにトップページへ遷移する
            else if ((this.$route.name === 'ContractNeoOrder' || this.$route.name === 'ContractNeoConfirm') && (this.neo_contract_status === '3' || this.neo_contract_status === '4' || this.neo_contract_status === '5')) {
              iAlert = 6
            }
            // chatが契約中の場合は、chatの契約申込画面へ遷移したにトップページへ遷移する
            else if ((this.$route.name === 'ContractChatOrder' || this.$route.name === 'ContractChatConfirm') && (this.chat_contract_status === '3' || this.chat_contract_status === '4' || this.chat_contract_status === '5')) {
              iAlert = 7
            }

            // エラーがある場合はトップページに遷移する
            if (iAlert !== 0) {
              this.$router.push({name: "TopPage", query: {'alert': iAlert}})
            }
          })
          .catch((error) => {
            // 未ログインの場合を除くエラーの場合はシステムエラーとする
            if (error.response.status !== 401) {
              this.$router.push({
                name: "SupportSystemError",
                params: {
                  error_msg: '画面表示処理'
                }
              })
            }
            // 未ログイン状態でログイン画面ではない場合はログイン画面へ遷移
            else if (this.$route.name !== 'Login') {
              this.$router.push({name: 'Login'})
            }
          })
          .finally(() => {
            // 読み込み完了
            this.isLoadingHeader = false
          })
      }
    }
  },
  created() {
    // 最初に画面表示前共通処理を実行する
    this.setHeader()
  },
  watch: {
    // 画面遷移の度に画面表示前共通処理を実行する
    $route: function () {
      this.setHeader()
    }
  }
}
</script>

<style scoped>
.stepper-style {
  width: 900px;
  background-color: #c0c0c0;
  color: #ffffff;
}
.active-step {
  background-color: #4169e1;
}
.inactive-step:hover {
  cursor : pointer;
}
.form-box {
  max-width: 1200px;
}
.next-icon {
  margin-top: 2px;
}
</style>
